import React from 'react';
import { Link } from 'react-router-dom';
import { toSSO } from '../../utils/location';
import GlobalImage from '../imgComponent/index'
import styles from './index.module.less';

const PageHeader = (props) => {
  const { type = 'homepage' } = props;

  const getClassName = () => {
    switch (type) {
      case 'homepage':

        return `${styles['box_4']} flex-row`;

      case 'download':

        return `${styles['box_4']} flex-row ${styles.active}`;

      case 'qcode-download':

        return `${styles['box_4']} ${styles['box_4_1']} flex-row ${styles.active}`;

      default:
        return `${styles['box_4']} flex-row`;
    }
  };

  return (
    <div className={`${styles['page-header']} flex-col justify-end`}>
      <div className={styles['box-wraper']}>
        <div className={`${styles['box_3']} flex-row`}>
          <GlobalImage className={`${styles['label_1']}`} src="logo-new-2x.png" alt="图片" />
          <Link to="/" className={type === 'homepage' ? `${styles['text_3']} ${styles.active}` : `${styles['text_3']}`}><span>首页</span></Link>
          <Link to="/official/download" className={type === 'download' ? `${styles['text_3']} ${styles.active}` : `${styles['text_3']}`}><span>下载APP</span></Link>
          {process.env.REACT_APP_MODE === 'dev' && (<Link to="/official/qcode-download" className={type === 'qcode-download' ? `${styles['text_3']} ${styles.active}` : `${styles['text_3']}`}><span>二维码</span></Link>)}
          <div className={`${styles['text-wrapper_2']} ${styles['zhuce']}`} onClick={() => toSSO('register')}>
              <span className={`${styles['text_5']}`}>注册</span>
          </div>
          <div className={`${styles['text-wrapper_2']}`} onClick={() => toSSO('login')}>
              <span className={`${styles['text_5']}`}>登录</span>
          </div>
        </div>
        <div className={getClassName()}>
          <div className={`${styles['box_5']} flex-col`} />
        </div>
      </div>
    </div>
  );
}

export default PageHeader;
